import { render, staticRenderFns } from "./ChangeCurrentAd.vue?vue&type=template&id=23566a81&"
import script from "./ChangeCurrentAd.vue?vue&type=script&lang=js&"
export * from "./ChangeCurrentAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports